import { compose, setDisplayName } from 'react-recompose';
import { reduxForm } from 'redux-form/immutable';

import { getFeatureFlags } from '~/state/ducks/app/selectors';
import {
    getUserData,
    getInitialFormData,
    getUserID,
} from '~/state/ducks/users/selectors';
import { fetchUser, patchUser } from '~/state/ducks/users/operations';

import withReduxConnect from '~/views/enhancers/withReduxConnect';
import withReduxDataLoading, { withLoadingBranch } from '~/views/enhancers/withReduxDataLoading';

import UserForm from '../components/UserForm';


export default compose(
    setDisplayName('UsersEditContainer'),
    withReduxConnect({
        mapStateToProps: state => ({
            initialValues: getInitialFormData(state),
            feature_flags: getFeatureFlags(state),
            linkToView: `../${getUserID(state)}`,
        }),
    }),
    withReduxDataLoading({
        name: 'fetchUserData',
        operation: ({ match: { params: { id } } }) => fetchUser(id),
        selector: getUserData,
    }),
    withLoadingBranch,
    reduxForm({
        form: 'users-edit',
        onSubmit: patchUser,
        enableReinitialize: true,
    }),
)(UserForm);
